import {authService} from "../Services/authService";

export class BaseService {
    async getToken(): Promise<string> {
        return authService.getIdentity().then(value => {
            return value.idToken;
        });
    }
}